<template>
    <div v-if="tmId" id="forumThread" class="w-100 mt-2 pr-2" style="height:100%;overflow-y: auto;">
        <!-- new thread -->
        <p>心得討論</p>
        <div class="d-flex w-100 mb-3">
            <!-- avator-->
            <div>
                <img class="author-avator-comment mr-2" :src="fmtUserAvator(user)"
                     alt="">
            </div>
            <!-- msg area -->
            <div class="flex-grow-1">
                <!-- input message -->
                <!--
                <p contenteditable="true" class="textarea" style="margin-bottom:0.3rem;" v-text="inputingComment"
                   @input="onInputComment($event)"></p>
                -->
                <editable-div v-model="inputingComment" class="mb-2"></editable-div>
                <div class="d-flex">
                    <button class="btn btn-success btn-sm ml-auto mr-0" style="line-height:1;" @click="postThread()">貼文</button>
                </div>
            </div>
        </div>
        <!-- exist thread items -->
        <div v-if="threads" class="w-100">
            <div v-for="(t, tIdx) in threads" :key="t.Id" class="d-flex w-100">
                <!-- avator-->
                <div>
                    <img class="author-avator-comment mr-2" :src="fmtAuthorAvatorUrl(t)" @click="onAuthorClicked(t)"
                         alt="">
                </div>
                <!-- msg area-->
                <div class="flex-grow-1 d-flex flex-column">
                    <!-- title bar -->
                    <div class="d-flex" style="font-size:0.8rem;">
                        <div class="flex-grow-1">{{t.UserDisplayName}}</div>
                        <div class="dropdown ml-auto mr-0">
                            <i class="dropdown-toggle" style="cursor:pointer;" data-toggle="dropdown"></i>
                            <ul class="dropdown-menu" role="menu">
                                <li><a v-if="t.UserId == user.HashedUserId" tabindex="-1" href="#" @click="deleteThread(null, t, tIdx)">刪除貼文</a></li>
                                <li><a v-if="t.UserId == user.HashedUserId" tabindex="-1" href="#" @click="onEditThread(t, tIdx)">編輯貼文</a></li>
                                <li class="divider"></li>
                                <li><a tabindex="-1" href="#">檢舉貼文</a></li>
                            </ul>
                        </div>
                    </div>
                    <editable-div v-if="t.isEditing" v-model="t.Message" style="margin-bottom:0.3rem;"></editable-div>
                    <div v-else v-html="t.Message" style="margin-bottom:0.3rem;"></div>
                    <div v-if="t.isEditing" class="d-flex" style="margin-bottom: 0.3rem;">
                        <button class="btn btn-success btn-sm ml-auto mr-2" style="line-height:1;" @click="finishedThreadEdit(t)">確定</button>
                        <button class="btn btn-success btn-sm mr-0" style="line-height:1;" @click="cancelThreadEdit(t)">取消</button>
                    </div>
                    <!-- the replied comments-->
                    <div v-if="t.RepliedComments">
                        <div v-for="r in t.RepliedComments" :key="r.Id" class="d-flex w-100">
                            <!-- avator-->
                            <div>
                                <img class="author-avator-comment mr-2" :src="fmtAuthorAvatorUrl(r)" @click="onAuthorClicked(r)"
                                     alt="">
                            </div>
                            <!-- message area-->
                            <div class="flex-grow-1 d-flex flex-column">
                                <div class="d-flex" style="font-size:0.8rem;">
                                    <div class="flex-grow-1">{{r.UserDisplayName}}</div>
                                    <div class="dropdown ml-auto mr-0">
                                        <i class="dropdown-toggle" style="cursor:pointer;" data-toggle="dropdown"></i>
                                        <ul class="dropdown-menu" role="menu">
                                            <li><a v-if="r.UserId == user.HashedUserId" tabindex="-1" href="#" @click="deleteThread(t, r, rIdx)">刪除貼文</a></li>
                                            <li><a v-if="r.UserId == user.HashedUserId" tabindex="-1" href="#" @click="onEditThread(r, rIdx)">編輯貼文</a></li>
                                            <li class="divider"></li>
                                            <li><a tabindex="-1" href="#">檢舉貼文</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <editable-div v-if="r.isEditing" v-model="r.Message" style="margin-bottom:0.3rem;"></editable-div>
                                <div v-else v-html="r.Message" style="margin-bottom:0.3rem;"></div>
                                <div v-if="r.isEditing" class="d-flex" style="margin-bottom: 0.3rem;">
                                    <button class="btn btn-success btn-sm ml-auto mr-2" style="line-height:1;" @click="finishedThreadEdit(r)">確定</button>
                                    <button class="btn btn-success btn-sm mr-0" style="line-height:1;" @click="cancelThreadEdit(r)">取消</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- the replying block -->
                    <div style="margin-bottom: 0.3rem;">
                        <div v-if="t.isReplying" class="d-flex w-100 mb-3">
                            <!-- avator-->
                            <div>
                                <img class="author-avator-comment mr-2" :src="fmtUserAvator(user)"
                                     alt="">
                            </div>
                            <!-- msg area -->
                            <div class="flex-grow-1">
                                <!-- input message -->
                                <editable-div v-model="t.replyingComment" class="mb-2"></editable-div>
                                <div class="d-flex">
                                    <button class="btn btn-success btn-sm ml-auto mr-0" style="line-height:1;"
                                            @click="replyThread(t)">
                                        回覆
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex">
                            <p v-if="t.RepliedCommentsCount > 0 && !t.repliedCommentsExpanded" class="clickable"
                               @click="expandRepliedComments(t)">{{t.RepliedCommentsCount}}條回覆，顯示回覆</p>
                            <p v-else class="clickable" @click="onReplyClicked(t)">回覆</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import EditableDiv from '@/components/Elements/EditableDiv.vue';
    import {
        fmtAuthorAvatorUrl,
        ghelper
    } from '@/lib/ghelper';

    export default {
        name: "TeachingMaterialComment",
        components: {
            'editable-div': EditableDiv,
        },
        props: {
            user: {
                type: Object,
                default: null,
            },
            tmId: {
                type: String,
                default: null,
            },
        },
        data: function () {
            return {
                threads: null,
                threadsTotal: null,

                inputingComment: null,
            };
        },
        methods: {
            fmtUserAvator: function (user) {
                return fmtAuthorAvatorUrl(user);
            },
            fmtAuthorAvatorUrl: function (item) {
                return fmtAuthorAvatorUrl(item);
            },
            onReplyClicked: function (t) {
                this.$set(t, 'isReplying', true);
            },
            onAuthorClicked: function (item) {
                var url = ghelper.getActionUrl('Show', 'Account');
                location.href = url + '/' + item.UserId;
            },
            onInputComment: function (e) {
                this.inputingComment = e.target.innerHTML;
            },
            cancelThreadEdit: function (t) {
                this.$set(t, 'isEditing', false);
                this.$set(t, 'Message', t.MessageBackup);
            },
            finishedThreadEdit: async function (t) {
                if (!t.Message) {
                    this.$dialog.alert('請輸入您的回覆');
                    return false;
                }

                var loader = this.$loading.show();
                try {
                    let res = await this.axios.post("Forum/ThreadUpdate", {
                        tId: t.Id,
                        msg: t.Message,
                    });
                    let data = res.data;
                    if (data.success) {
                        this.$set(t, 'isEditing', false);
                    } else if (data.success == false) {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert('無法更新貼文。發生不知名的錯誤');
                    loader.hide();
                }
            },
            onEditThread: function (t) {
                t.MessageBackup = t.Message;
                this.$set(t, 'isEditing', true);
            },
            replyThread: async function (t) {
                if (!t.replyingComment) {
                    this.$dialog.alert('請先輸入您的回覆。');
                    return;
                }

                var loader = this.$loading.show();
                try {
                    let res = await this.axios.post("Forum/TeachingMaterialThreadReply", {
                        tmId: this.tmId,
                        pid: t.Id,
                        msg: t.replyingComment,
                    });

                    let data = res.data;
                    if (data.success) {
                        let repliedCommentsCount = t.RepliedCommentsCount;

                        if (t.RepliedComments) {
                            t.RepliedComments.push(data.data);
                        } else {
                            let repliedComments = [];

                            repliedComments.push(data.data);
                            this.$set(t, 'RepliedComments', repliedComments);
                        }

                        this.$set(t, 'isReplying', false);
                        this.$set(t, 'replyingComment', null);
                        this.$set(t, 'repliedCommentsExpanded', true);
                        this.$set(t, 'RepliedCommentsCount', repliedCommentsCount + 1);
                    } else if (data.success == false) {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert('無法回覆貼文。發生不知名的錯誤');
                    loader.hide();
                }
            },
            postThread: async function () {
                if (!this.inputingComment) {
                    this.$dialog.alert('請先輸入您的討論。');
                    return;
                }

                var loader = this.$loading.show();
                try {
                    let res = await this.axios.post("Forum/TeachingMaterialThreadCreate", {
                        tmId: this.tmId,
                        msg: this.inputingComment,
                    });
                    let data = res.data;
                    if (data.success) {
                        this.threads.push(data.data);
                        this.inputingComment = null;

                        // scroll to new added thread after ui updated.
                        this.$nextTick(function () {
                            let elem = document.getElementById("forumThread");
                            elem.scrollTop = elem.scrollHeight;
                        });
                    } else if (data.success == false) {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert('無法建立貼文。發生不知名的錯誤');
                    loader.hide();
                }
            },
            deleteThread: async function (parent, t, tIdx) {
                let container = parent ? parent.RepliedComments : this.threads;

                var loader = this.$loading.show();
                try {
                    let res = await this.axios.post("Forum/ThreadDelete", {
                        tid: t.Id,
                    });
                    let data = res.data;
                    if (data.success) {
                        if (parent) {
                            let repliedCommentsCount = parent.RepliedCommentsCount
                            this.$set(parent, 'RepliedCommentsCount', repliedCommentsCount - 1);
                        }
                        container.splice(tIdx, 1);
                    } else if (data.success == false) {
                        this.$dialog.alert(data.message);
                    }
                    loader.hide();
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert('無法刪除貼文。發生不知名的錯誤');
                    loader.hide();
                }
            },
            expandRepliedComments: async function (t) {
                try {
                    let res = await this.axios.post("Forum/GetRepliedComments", {
                        pid: t.Id,
                    });
                    let data = res.data;
                    if (data.success) {
                        let replies = data.data;

                        this.$set(t, 'RepliedComments', replies);
                        this.$set(t, 'repliedCommentsExpanded', true);
                    } else if (data.success == false) {
                        this.$dialog.alert(data.message);
                    }
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert('無法取得討論串回覆。發生不知名的錯誤');
                }
            },
            getThreads: async function () {
                try {
                    let res = await this.axios.post("Forum/GetTeachingMaterialThreads", {
                        tmId: this.tmId,
                    });
                    let data = res.data;
                    if (data.success) {
                        let threads = data.data;

                        this.threads = threads;
                        this.threadsTotal = data.total;
                    } else if (data.success == false) {
                        this.$dialog.alert(data.message);
                    }
                } catch (error) {
                    if (error.response) {
                        // 當狀態碼不在 validateStatus 設定的範圍時進入, 401 感覺會跑來這。待確認
                        // 有 data / status / headers 參數可用
                        console.log(error.response.status);
                    } else if (error.request) {
                        // 發送請求，但沒有接到回應
                        // error.request is an instance of XMLHttpRequest in the browser
                        // and an instance of http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // 在設定 request 時出錯會進入此
                        console.log("Error", error.message);
                    }
                    this.$dialog.alert('無法取得學習記錄的貼文串。發生不知名的錯誤');
                }
            },
            initData: function () {
                this.getThreads();
            },
        },
        mounted: function () {
            this.initData();
        },
        created() {
        }
    }
</script>
<style>
    /* ideas from here: https://css-tricks.com/auto-growing-inputs-textareas */

    .clickable:hover {
        cursor: pointer;
    }

    .author-avator-comment {
        width: 25px !important;
        height: 25px !important;
        border: 1px solid #ebebeb;
        border-radius: 50%;
        overflow: hidden;
        background-color: #a9a9a9;
        cursor: pointer;
    }
    
</style>
